export const flatCartItemsWithAddon = (cartItems) => {
  return cartItems.concat(cartItems.flatMap((item) => item?.addon_items ?? []));
};

export const getTrackItem = (productId, variationId, type, cartItems) => {
  const itemInfo = {
    type: type,
    product_id: productId,
    variation_id: variationId,
    quantity: 0,
    price: 0,
  };
  cartItems.forEach((item) => {
    if (isSameItem(item, itemInfo)) {
      itemInfo.type = item.type;
      itemInfo.quantity += item.quantity || 0;
      itemInfo.price += item.total ? item.total.dollars : 0;
    }
  });
  return itemInfo;
};

export const isSameItem = (targetItem, expectItem) => {
  const isProduct = targetItem.product_id === expectItem.product_id;
  const isVariation =
    !expectItem.variation_id ||
    targetItem.variation_id === expectItem.variation_id;
  const isType = !expectItem.type || targetItem.type === expectItem.type;

  return isProduct && isVariation && isType;
};
